const errorPrefix = 'errors.formFields.';

const ukPostcode = (value) => {
  // regex expression shouldn't be split across multiple lines
  // eslint-disable-next-line max-len
  const pattern = /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$/;

  if (!(pattern.test(value))) {
    return `${errorPrefix}postalCode`;
  }
};

export default ukPostcode;
